export var ContextEventName;
(function (ContextEventName) {
    ContextEventName["ValueUpdate"] = "knyt-value-update";
    ContextEventName["ContextRequest"] = "knyt-context-request";
    ContextEventName["ContextProviderAvailable"] = "knyt-context-provider-available";
})(ContextEventName || (ContextEventName = {}));
export class ContextRequestEvent extends Event {
    contextKey;
    handleValueUpdate;
    subscription = Promise.withResolvers();
    resubscribe;
    #subscriptionIsSettled = false;
    get wasHandled() {
        return this.#subscriptionIsSettled;
    }
    constructor({ contextKey, handleValueUpdate, resubscribe, }) {
        super(ContextEventName.ContextRequest, {
            bubbles: true,
            composed: true,
        });
        this.contextKey = contextKey;
        this.handleValueUpdate = handleValueUpdate;
        this.resubscribe = resubscribe;
        this.subscription.promise.finally(() => {
            this.#subscriptionIsSettled = true;
        });
    }
}
export class ContextProviderAvailableEvent extends Event {
    contextKey;
    constructor(contextKey) {
        super(ContextEventName.ContextProviderAvailable, {
            bubbles: true,
            composed: true,
        });
        this.contextKey = contextKey;
    }
}
